import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { VesselsComponent } from './vessels.component';
import { VesselsResolve } from './vessels.resolve';
import { PortalComponent } from '../../portal.component';
import { PortalResolve } from '../../portal.resolve';
import { BoatyardComponent } from '../../profile/captain/boatyard/boatyard.component';
import { BoatyardResolve } from '../../profile/captain/boatyard/boatyard.resolve';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'manage/admin',
        component: PortalComponent,
        resolve: {
          portal: PortalResolve,
        },
        children: [
          {
            path: 'vessels',
            component: VesselsComponent,
            resolve: {
              portal: VesselsResolve,
            },
          },
          {
            path: 'vessel/:id',
            component: BoatyardComponent,
            resolve: {
              portal: BoatyardResolve,
            },
          },
        ],
      },
    ]),
  ],
  exports: [RouterModule],
})
export class VesselsRoutingModule {}
